import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import postGenerateSchedule from 'Api/schedule-generate/postGenerateSchedule';

import { useScheduleGenerateState } from 'View/schedule-generate/state';

import postGenerateScheduleRequest from './model/request/postGenerateScheduleRequest';

const usePostGenerateSchedule = () => {
  const { t } = useTranslation('schedule-generate');
  const { resetState } = useScheduleGenerateState();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (data) => {
      const payload = postGenerateScheduleRequest(data);

      const response = await postGenerateSchedule(payload);

      return response;
    },
    onMutate: () => {
      onShowLoader({ variant: 'loader-primary' });
    },
    onSuccess: () => {
      resetState();
      navigate('/schedule/calendar');
      onOpenToast({
        status: 'success',
        description: t('postGenerateSuccess'),
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: () => {
      onOpenToast({
        status: 'error',
        title: t('errorTitleToast'),
        description: t('postGenerateError'),
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default usePostGenerateSchedule;
